import winter from './winter.schedule-template';
import summer from './summer.schedule-template';


export default [
  winter,
  summer,
];



